export default __webpack_public_path__ + "static/media/Company.e6edbecc.svg";